export default __webpack_public_path__ + "static/media/E-Standard.df4a3dcb.png";